// @flow
import * as React from 'react';
import { Container, Header, Content, Footer, Modal } from './modal';

import FormSubmitButtons from '../form_submit_buttons';

import type { ModalProps } from './shared';

type ModalWithSubmitActionProps = ModalProps & {
  onSubmit: Function,
  onCancel?: Function,
  submitText?: string,
  cancelText?: string,
  disabled?: boolean,
  hideCancelButton?: boolean,
  className?: string,
  fancy?: boolean,
  draggable?: boolean,
  disableEnforceFocus?: boolean,
  extraActions?: ?any,
};

const ModalWithSubmitActions = (props: ModalWithSubmitActionProps) => {
  const { id, className, children, extraActions, onSubmit, ...restProps } =
    props;

  return (
    <Modal>
      <Container id={id} className={className} {...restProps}>
        <Header {...restProps} />
        <Content {...restProps} draggable={false}>
          {children}
        </Content>
        <Footer>
          <FormSubmitButtons
            onSubmit={onSubmit}
            onCancel={props.onCancel || props.closeModal}
            {...restProps}
            compact={true}
          >
            {extraActions}
          </FormSubmitButtons>
        </Footer>
      </Container>
    </Modal>
  );
};

export default ModalWithSubmitActions;

ModalWithSubmitActions.defaultProps = {
  open: false,
  fullScreen: false,
  fullWidth: false,
  maxWidth: 'md',
  displayXIcon: true,
  dividers: true,
  draggable: true,
};
